import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SubscriptionInvoiceSearch from "./SubscriptionInvoiceSearch";
import UELoaderAnim from "../UELoaderAnim";
import UEConfirmModal from "../crud/UEConfirmModal";
import Styles from "./Subscription.scss";
import Style from "./USerDocTableV3.scss";
import StatusForm from "./StatusForm";

const SubscriptionInvoices = ({ props }) => {
   const [isLoading, setIsLoading] = useState(false);
   const [invoices, setInvoices] = useState([]);
   const [upcoming, setUpcoming] = useState([]);
   const [filter, setFilter] = useState();
   const [filteredData, setFilteredData] = useState([]);
   const [pageCount, setPageCount] = useState(8);
   const [currentIndex, setCurrentIndex] = useState(0);
   const [lines, setLines] = useState();
   const [showLines, setShowLines] = useState();

   useEffect(() => {
      getInvoices();
   }, []);

   useEffect(() => {}, [filter]);

   const onSearch = (val, options) => {
      setFilter({
         ...options,
         critter: val,
      });
      setCurrentIndex(0);
   };
   const setPaginationUrl = () => {
      let content = [];
      let indexStart = 0;
      for (let i = 0; i < filteredData.length; i += pageCount) {
         content.push(
            <li key={i} className="page-item">
               <a className="page-link" href="#" onClick={(e) => setCurrentIndex(i)}>
                  {indexStart + 1}
               </a>
            </li>
         );
         indexStart += 1;
      }
      return content;
   };

   const getInvoices = async (filter) => {
      setIsLoading(true);
      try {
         const response = await axios.get("/Api/stripe/customer/invoices");
         //console.log(response?.data);
         setInvoices(response.data?.invoices?.data);
         setUpcoming(response?.data?.upcoming);
         setLines(response?.data?.lines?.data);
         console.log(response?.data?.upcoming);
      } catch (e) {
         console.log(e);
      }
      setIsLoading(false);
   };
   
   const renderInvoiceRow = (item, type = null) => {
      const contenu = item.subscription ? "Abonnement" : "Formulaires";
      const classeDeStyle = contenu === "Abonnement" ? "style-vert" : contenu === "Formulaires" ? "style-bleu" : "";

       console.log(item);
      return (
         <tr key={item.id}>
            <td className="text-center">
               <span className={`contenu-encadre ${classeDeStyle}`}>{contenu}</span>
            </td>
            <td className={"text-center"}> Carte</td>
            <td className={"text-center"}>{item?.number} </td>
            <td className={"text-center"}>{item?.customer_name}</td>
            <td className={"text-center"}>{item?.customer_email} </td>
            <td className={"text-center"}>{new Date(item?.created * 1000).toLocaleString("fr-FR")}</td>
            <td className={"text-center"}>
               {new Intl.NumberFormat("fr-FR", {
                  style: "currency",
                  currency: "EUR",
               }).format(item?.total_excluding_tax / 100)}
            </td>
            <td className={"text-center"}>
               {new Intl.NumberFormat("fr-FR", {
                  style: "currency",
                  currency: "EUR",
               }).format(item?.total / 100)}
            </td>
            <td className={"text-center"}>
               <StatusForm status={item?.status} />
            </td>
            <td className={"text-center"}>
               {type==='upcoming' ?(
                   <div className={"text-muted"} >
                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                      <path
                         fill="currentColor"
                         d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                      />
                   </svg>
                </div>
               ):(
                  <div
                  className={"btn text-primary"}
                  onClick={() =>
                     type === "upcoming" ? setShowLines(lines) : window.open(item?.invoice_pdf, "_blanck")
                  }
               >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                     <path
                        fill="currentColor"
                        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z"
                     />
                  </svg>
               </div>
               )}
              
            </td>
         </tr>
      );
   };

   const renderUpcommingLines = (item) => {
      return (
         <div
            key={item.id}
            className={"d-flex w-100 justify-content-between align-items-center my-2 border rounded p-2"}
            style={{
               boxShadow: "inset rgb(119 119 119 / 30%) 1px 1px 3px 0px",
            }}
         >
            <div className={"d-flex flex-column w-100 text-sm"}>
               <div className={"my-1 font-weight-bold text-primary"}>{item.description}</div>
               <div className={"d-flex justify-content-end align-items-center my-2"}>
                  <div className={"text-center"}>
                     {item?.period?.start ? new Date(item?.period?.start * 1000).toLocaleString("fr-FR") : null}
                  </div>
                  <div className={"text-center"}>{item?.quantity}</div>
                  <div className={"text-center"}>
                     {item?.price.unit_amount || item?.price.unit_amount === 0
                        ? new Intl.NumberFormat("fr-FR", {
                             style: "currency",
                             currency: "EUR",
                          }).format(item?.price?.unit_amount / 100)
                        : "..."}
                  </div>
                  <div className={"text-center"}>
                     {item.amount || item.amount === 0
                        ? new Intl.NumberFormat("fr-FR", {
                             style: "currency",
                             currency: "EUR",
                          }).format(item.amount / 100)
                        : "0"}
                  </div>
                  <div
                     className={"text-center font-weight-bold"}
                     // style={{ width: "100px" }}
                  >
                     {item.amount_excluding_tax || item.amount_excluding_tax === 0
                        ? new Intl.NumberFormat("fr-FR", {
                             style: "currency",
                             currency: "EUR",
                          }).format(item.amount_excluding_tax / 100)
                        : "-"}
                  </div>
               </div>
            </div>
         </div>
      );
   };

   return (
      <div
         className={"d-flex flex-column justify-content-start align-items-start rounded w-100 bg-white"}
         style={{ padding: "0px 40px 0px 40px" }}
      >
         {isLoading ? (
            <div className="w-100 text-center">
               <UELoaderAnim size={30} />
            </div>
         ) : (
            <div className={"d-flex flex-column justify-content-center align-items-center w-100"}>
               <div className={"d-flex align-items-center w-100 my-3 flex-column flex-md-row"}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                     <div className={"mr-4"}>
                        <svg width="26" height="23" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <rect width="26" height="23" rx="4" fill="#F1F4F4" />
                           <path
                              d="M16.8143 11.9275L11.6809 16.8229C11.4333 17.059 11.032 17.059 10.7844 16.8229L10.1857 16.2519C9.93852 16.0162 9.93805 15.6342 10.1846 15.398L14.2529 11.5L10.1846 7.60201C9.93805 7.36575 9.93852 6.98375 10.1857 6.74805L10.7844 6.17708C11.032 5.94097 11.4334 5.94097 11.6809 6.17708L16.8143 11.0725C17.0619 11.3086 17.0619 11.6914 16.8143 11.9275Z"
                              fill="#9A9A9A"
                           />
                        </svg>
                     </div>
                     <div className={"h6 font-weight-bold mb-0 "} style={{ width: "170px" }}>
                        Mes factures
                     </div>
                  </div>
                  <div className={"w-100 text-center"}>
                     <SubscriptionInvoiceSearch onSearch={onSearch} />
                  </div>
               </div>
               <div className={"d-flex  flex-column justify-content-center align-items-center w-100 my-3"}>
                  <div className="table-responsive">
                     <table className={"table table-sm ue-dashboard-table-v3 ue-invoice-table"}>
                        <thead>
                           <tr>
                              <th className={"text-center"}>Type</th>
                              <th className={"text-center"}>Mode</th>
                              <th className={"text-center"}>N° Facture</th>
                              <th className={"text-center"}>Client / Structure</th>
                              <th className={"text-center"}>Email</th>
                              <th className={"text-center"}>Date</th>
                              <th className={"text-center"}>Prix HT</th>
                              <th className={"text-center"}>Prix TTC</th>
                              <th className={"text-center"}>Statut</th>
                              <th className={"text-center"}>Facture</th>
                           </tr>
                        </thead>
                        {upcoming ? <tbody>{upcoming.id ?? renderInvoiceRow(upcoming, "upcoming")}</tbody> : null}

                        {invoices?.length ? <tbody>{invoices.map((item) => renderInvoiceRow(item))}</tbody> : null}
                     </table>
                     {!invoices?.length ? (
                        <div className={"d-flex justify-content-center align-items-center w-100 text-center my-3"}>
                           Aucun élément à afficher !
                        </div>
                     ) : null}
                     <nav aria-label="">
                        <ul className="pagination justify-content-center">
                           <li className="page-item">
                              <a
                                 className="page-link"
                                 href="#"
                                 aria-label="Previous"
                                 onClick={(e) => setCurrentIndex(0)}
                              >
                                 <span aria-hidden="true">&laquo;</span>
                              </a>
                           </li>
                           {filteredData?.length ? setPaginationUrl() : null}
                           <li className="page-item">
                              <a
                                 className="page-link"
                                 href="#"
                                 aria-label="Next"
                                 onClick={(e) => setCurrentIndex(filteredData?.length - pageCount)}
                              >
                                 <span aria-hidden="true">&raquo;</span>
                              </a>
                           </li>
                        </ul>
                     </nav>
                  </div>
               </div>
            </div>
         )}
         <UEConfirmModal
            onClose={() => setShowLines(false)}
            isOpened={showLines}
            title={"Prochaine facturation le " + new Date(upcoming?.created * 1000).toLocaleDateString("fr-FR")}
            showButtons={false}
         >
            <div style={{ overflowY: "auto", maxHeight: "85vh" }}>
               <div className={"d-flex justify-content-end align-items-center w-100 py-4"}>
                  <div className={"text-center"} style={{ width: "150px" }}>
                     Date
                  </div>
                  <div className={"text-center"} style={{ width: "50px" }}>
                     Quantité
                  </div>
                  <div className={"text-center"} style={{ width: "100px" }}>
                     Prix unitaire
                  </div>
                  <div className={"text-center"} style={{ width: "100px" }}>
                     Total
                  </div>
                  <div className={"text-center"} style={{ width: "100px" }}>
                     Total H.T
                  </div>
               </div>
               {lines?.length ? lines?.map((item) => renderUpcommingLines(item)) : null}
            </div>
         </UEConfirmModal>
      </div>
   );
};
const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      structureInfo: state.SubscribtionReducer.structureInfo,
      entity: state.MeReducer.entity,
      currentSubscriptions: state.MeReducer.currentSubscription,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(SubscriptionInvoices);
